import React from "react"
import DateInfoDiv from "../components/HomeComponents/DateInfoDiv"
import LandingPageText from "../components/HomeComponents/LandingPageText"
import AnimatedChili from "../components/AnimatedChili/AnimatedChili"
import MatchArticle from "../components/HomeComponents/MatchArticle"
import MapArticle from "../components/HomeComponents/MapArticle"
import AltLanding from "../components/HomeComponents/AltLanding"
import { getPrefersDarkMode } from "../hooks/setThemeColor"

const blobColor = getPrefersDarkMode() ? "#262626" : "#e4e4e7"

const Home = () => {
    return (
        <div className="overflow-hidden">
            <div className="relative  w-full min-h-svh lg:min-h-0 h-auto  grid place-items-center">
                <div
                    style={{ gridColumn: 1, gridRow: 1 }}
                    className="z-20 pb-safe-nav"
                >
                    <div className="grid grid-cols-1 lg:pt-16 lg:grid-cols-2 gap-4 w-full max-w-6xl mx-auto ">
                        <LandingPageText />
                        <DateInfoDiv />
                    </div>
                </div>
                <div
                    style={{ gridColumn: 1, gridRow: 1 }}
                    className="flex w-full h-full items-center justify-center z-10 overflow-hidden bg-gradient-to-b from-primary-500 to-primary-800 relative"
                >
                    <div className="absolute -top-2 bottom-16 left-1/2 -translate-x-1/2   w-full max-w-4xl flex items-center justify-center">
                        <AnimatedChili
                            classes={
                                " h-full aspect-square  hidden lg:block rotate-[135deg]   opacity-25"
                            }
                        />
                        <AnimatedChili
                            classes={
                                " h-full aspect-square  -rotate-45  opacity-25 -translate-x-16 lg:translate-x-0"
                            }
                        />
                    </div>
                </div>
            </div>
            <svg
                width="900"
                className="min-w-full"
                viewBox="0 0 1600 61"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0 36L38.08 33.7C76.32 31.3 152.48 26.7 228.8 28.3C305.12 30 381.28 38 457.6 44.3C533.92 50.7 610.08 55.3 686.08 51C762.08 46.7 837.92 33.3 913.92 33.8C989.92 34.3 1066.08 48.7 1142.4 55.3C1218.72 62 1294.88 61 1371.2 56.3C1447.52 51.7 1523.68 43.3 1561.92 39.2L1600 35V0H1561.92C1523.68 0 1447.52 0 1371.2 0C1294.88 0 1218.72 0 1142.4 0C1066.08 0 989.92 0 913.92 0C837.92 0 762.08 0 686.08 0C610.08 0 533.92 0 457.6 0C381.28 0 305.12 0 228.8 0C152.48 0 76.32 0 38.08 0H0V36Z"
                    fill="#9a2c1a"
                />
            </svg>
            <AltLanding blobColor={blobColor} />
            <div className="bg-neutral-100 dark:bg-neutral-800/40">
                <MapArticle blobColor={blobColor} />
            </div>
            <MatchArticle blobColor={blobColor} />
        </div>
    )
}

export default Home
